import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isCoursesOpen, setIsCoursesOpen] = useState(false);
  const location = useLocation();

  const courses = [
    { name: 'Drones', path: '/courses#drones' },
    { name: 'Embedded Systems', path: '/courses#embedded' },
    { name: 'Frontend Web Development', path: '/courses#frontend' },
    { name: 'Ethical Hacking Basics', path: '/courses#hacking' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/90 backdrop-blur-sm' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">
                JK SemiTech
              </span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center">
            <div className="ml-10 flex items-baseline space-x-4">
              <Link to="/" className="px-3 py-2 text-gray-300 hover:text-white transition-colors">
                Home
              </Link>
              
              <div className="relative group">
                <button
                  className="px-3 py-2 text-gray-300 hover:text-white transition-colors flex items-center"
                  onClick={() => setIsCoursesOpen(!isCoursesOpen)}
                >
                  Courses
                  <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                <div className="absolute z-10 left-0 mt-2 w-48 rounded-md shadow-lg bg-gray-800 ring-1 ring-black ring-opacity-5 hidden group-hover:block">
                  <div className="py-1">
                    {courses.map((course) => (
                      <Link
                        key={course.path}
                        to={course.path}
                        className="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white"
                      >
                        {course.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              <Link to="/about" className="px-3 py-2 text-gray-300 hover:text-white transition-colors">
                About
              </Link>
              <Link to="/contact" className="px-3 py-2 text-gray-300 hover:text-white transition-colors">
                Contact
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-white focus:outline-none"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-sm">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link to="/" className="block px-3 py-2 text-gray-300 hover:text-white">
              Home
            </Link>
            <button
              onClick={() => setIsCoursesOpen(!isCoursesOpen)}
              className="w-full text-left px-3 py-2 text-gray-300 hover:text-white"
            >
              Courses
            </button>
            {isCoursesOpen && (
              <div className="pl-6">
                {courses.map((course) => (
                  <Link
                    key={course.path}
                    to={course.path}
                    className="block px-3 py-2 text-gray-400 hover:text-white"
                  >
                    {course.name}
                  </Link>
                ))}
              </div>
            )}
            <Link to="/about" className="block px-3 py-2 text-gray-300 hover:text-white">
              About
            </Link>
            <Link to="/contact" className="block px-3 py-2 text-gray-300 hover:text-white">
              Contact
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;